<template>
    <div
        v-if="entry"
        class="template template--overview"
    >
        <SearchIndex
            index-name="grants"
            :limit="1000"
        >
            <div class="template__header">
                <SfHero :title="entry.title" />

                <div class="template__filters">
                    <SfPageContainer>
                        <SfFiltersSkipLink target="#grants-main" />

                        <SfGrantsOverviewFilters />
                    </SfPageContainer>
                </div>
            </div>

            <div
                id="grants-main"
                tabindex="-1"
                class="template__body"
                dark-theme-allowed="forced"
            >
                <SfPageContainer>
                    <AisHits
                        v-slot="{ items }"
                        :transform-items="transformGrantItems"
                    >
                        <section v-if="items?.length">
                            <div
                                v-for="{ openGrants, closedGrants } in [categorizeGrants(items)]"
                                :key="`categorized-${openGrants.length}-${closedGrants.length}`"
                            >
                                <h3 class="sf-grant-card__title ">
                                    {{ t('open') }}
                                    <span v-if="items">({{ openGrants.length }})</span>
                                </h3>
                                <SfGrantsList v-if="openGrants.length > 0">
                                    <SfGrantCard
                                        v-for="(grant, i) in openGrants"
                                        :key="`open-${i}`"
                                        :grant="grant"
                                    />
                                </SfGrantsList>
                                <p v-else> {{ t('no-grants-open') }} </p>

                                <h3 class="sf-grant-card__title sf-grant-card__title--closed">{{ t('closed') }}</h3>
                                <SfGrantsList v-if="closedGrants.length">
                                    <SfGrantCard
                                        v-for="(grant, i) in closedGrants"
                                        :key="`closed-${i}`"
                                        :grant="grant"
                                    />
                                </SfGrantsList>
                            </div>
                        </section>
                    </AisHits>
                </SfPageContainer>
            </div>

            <AisPagination v-show="false" />
        </SearchIndex>
    </div>
</template>

<script setup>
import { AisHits, AisPagination } from 'vue-instantsearch/vue3/es/index.js';
import { grantItems as transformGrantItems } from '~/helpers/ais-transforms';
import { categorizeGrants } from '~/helpers/grants-open';

import SfFiltersSkipLink from '~/patterns/atoms/filters-skip-link/filters-skip-link.vue';
import SfGrantsOverviewFilters from '~/patterns/organisms/filters/presets/grants-overview.vue';
import SfGrantsList from '~/patterns/organisms/grants-list/grants-list.vue';
import SfGrantCard from '~/patterns/molecules/grant-card/grant-card.vue';
import SfHero from '~/patterns/organisms/hero/hero';
import SfPageContainer from '~/patterns/organisms/page-container/page-container';
import GetPageQuery from '~/graphql/queries/pages/getPage.graphql';

false && /*#__PURE__*/ defineI18nRoute({
    paths: {
        nl: '/subsidies',
        en: '/grants'
    }
});

const { t } = useI18n({
    useScope: 'local'
});

const { variables } = useDefaultVariables();

const response = await useAsyncQuery({
    query: GetPageQuery,
    variables
});

const { craftEntry: entry } = useEntryPage(response);

useNavigationVisible();
</script>

<style lang="less">
.sf-grant-card__title--closed {
    margin-top: 2.25rem;

    @media @q-sm-min {
        margin-top: 3.125rem;
    }
}
</style>


<i18n lang="json">
{
    "nl": {
        "open": "open",
        "closed": "nu gesloten",
        "no-grants-open": "Op dit moment zijn er geen openstaande regelingen, open oproepen of vouchers. Bekijk de gesloten regelingen hieronder om je alvast in te lezen voor nieuwe aanvraagrondes."
    },
    "en": {
        "open": "open",
        "closed": "now closed",
        "no-grants-open": "There are no open grants, open calls or vouchers at the moment. Check the closed grants below to stay informed about new funding opportunities."
    }
}
</i18n>
